import classNames from "classnames";
import { LanguageType } from "types/localization";
import Checkbox from "../Checkbox";
import "./styles.sass";

type LanguageItemProps = {
  language: LanguageType;
  active?: boolean;
  onClick: (isoCode: string) => void;
};

const LanguageItem = ({
  language,
  active = false,
  onClick,
}: LanguageItemProps) => {
  if (!language) {
    return null;
  }

  const languageNameClass = classNames("LanguageItem__name_orig", {
    active,
  });

  const handleClick = () => {
    onClick(language.isoCode);
  };

  return (
    <button className="LanguageItem" type="button" onClick={handleClick}>
      <div className="LanguageItem__wrapper">
        <img
          src={language.img}
          alt={language.isoCode}
          className="LanguageItem__flag"
        />
        <div className="LanguageItem__name">
          <div className={languageNameClass}>{language.orig}</div>
        </div>
      </div>
      <div className="LanguageItem__checkbox">
        <Checkbox
          name={`current-language-${language.name}`}
          borderNone
          mode="dark"
          checked={active}
        />
      </div>
    </button>
  );
};

export default LanguageItem;
